import React from 'react';
import classNames from 'classnames';
import styles from './assets/legend.module.scss';
import SeanceEnum from '../../enumerables/seance-enum';
import { isHiddenSeanceStatus } from '../../helpers/seance/seanceStatus';

interface Props {}

const LegendComponent: React.FunctionComponent<Props> = (props) => {
    const statusListC: { [key: string]: string } = {
        '1': 'upcomingSt',
        '2': 'inProgressSt',
        '3': 'unconfirmSt',
        '4': 'confirmSt',
        //  '5': 'cancelSt',
        '6': 'billedSt',
        '7': 'paidSt',
    };
    const statusEnum = SeanceEnum ? SeanceEnum.getEnum('SeanceStatus') : {};

    delete statusEnum['Canceled'];
    const seancesStatuses = Object.keys(statusEnum)
        .map((it, k) => {
            const id = `${statusEnum[it]}`;

            return { id, label: it, color: statusListC[id] };
        })
        .filter((it) => !isHiddenSeanceStatus(it.id));

    return (
        <div className={classNames(styles.statuses)}>
            {seancesStatuses.map((it, k) => (
                <div key={`stat-${k}`} className={classNames(styles.statusItem)}>
                    <span className={classNames(styles.statusColor, it.color)}></span>
                    <span className={classNames(styles.status)}>{`${it.label}`}</span>
                </div>
            ))}
        </div>
    );
};

export default LegendComponent;
